/**
 * @generated SignedSource<<7f76555375cc5d69537ff88f87a14703>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type InternSidebarBrandsQuery$variables = {};
export type InternSidebarBrandsQuery$data = {
  readonly internBrands: ReadonlyArray<{
    readonly displayName: string;
    readonly id: string;
  }>;
};
export type InternSidebarBrandsQuery = {
  response: InternSidebarBrandsQuery$data;
  variables: InternSidebarBrandsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "BrandType",
    "kind": "LinkedField",
    "name": "internBrands",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "InternSidebarBrandsQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "InternSidebarBrandsQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "5a65e82024b63137af499d1cf1729a0b",
    "id": null,
    "metadata": {},
    "name": "InternSidebarBrandsQuery",
    "operationKind": "query",
    "text": "query InternSidebarBrandsQuery {\n  internBrands {\n    id\n    displayName\n  }\n}\n"
  }
};
})();

(node as any).hash = "49badeef5553e6bec1c1de948c3b0839";

export default node;
